module.exports = __webpack_public_path__ + "static/media/filling-pink.401d7268.png";